import deepmerge from 'deepmerge';
import {ENVIRONMENT_GLOBAL} from '../global_env';

export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'dev',
  production: true,
  matomoSrc: 'https://matomo.meinhplus.de/statistic/js/container_EfEzdlyc_dev_831007dcb8e74d63136d1def.js',
  redirect: {
    host: 'https://dev-oms.meinhplus.de'
  },
  auth_L1: {
    client_id: 'oms-tool',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://dev-account.meinhplus.de',
      paths: {
        prefix: '/auth/realms/hekatron-tuer-tor'
      }
    }
  },
  backend: {
    scope: 'oms',
    client_id: 'oms-webapp-aS1hG5kPl7Mn0ZxC',
    endpoint: {
      host: 'https://api.dev-oms.meinhplus.de'
    },
    wsEndpoint: 'wss://api.dev-oms.meinhplus.de/ws'
  },
  links: {
    applications: {
      mh2: {
        host: 'https://dev.meinhplus.de'
      },
      hcp: {
        host: 'https://dev-dashboard.meinhplus.de'
      },
      l2: {
        host: 'https://dev-administration.meinhplus.de',
        domains: '/multi-domain-mgmt'
      },
      go: {
        host: 'https://dev-asdconfig.meinhplus.de/securismokegoapp/de/'
      },
      hpo: {
        host: 'https://dev-operator.meinhplus.de'
      },
      b2b: {
        host: 'https://dev-shop.meinhplus.de'
      },
      dongle: {
        host: 'https://platform.meinhplus.de/#/licenses/dongle-management', // not correct
      },
      dongle_admin: {
        host: 'https://dev-permissions.meinhplus.de'
      },
      learn_world: {
        host: 'https://dev-lernwelt.meinhplus.de'
      }
    },
    api_key_doc: 'https://api.dev-oms.meinhplus.de/docu',
  }
});
